/* eslint-disable indent */
import React from "react";
import styles from "../stylesERv2.module.scss";

export const BloqueBTable = ({
  modoCombinado,
  verUltimos12Meses,
  bloqueBCollapsed,
  setBloqueBCollapsed,
  hardwareMensualesCombinados,
  ingresosHardwareMensual,
  monthsToShow,
  openHardwareIngresosModal,
  formatCurrency,
  formatPercentage,
  porcentajeSobreFacturacion,
  ytdIngresosHardware,
  compraHardwareMensual,
  instalacionMensual,
  materialesMensual,
  otrosCostosMensual,
  openHardwareFlexModal,
  onDetalleFactura,
  ytdCompraHardware,
  ytdInstalacion,
  ytdMateriales,
  ytdOtrosCostosHardware,
  ytdMargenHardware,
  margenPorcentaje,
}) => (
  <>
    {/* === BLOQUE B - Hardware === */}
    <tr
      className={styles.sectionHeader}
      onClick={(e) => {
        e.stopPropagation();
        if (!modoCombinado) setBloqueBCollapsed(!bloqueBCollapsed);
      }}
      style={{ cursor: modoCombinado ? "default" : "pointer", userSelect: "none" }}
    >
      <td className={styles.conceptCell}>
        B - Hardware {!modoCombinado && !verUltimos12Meses && bloqueBCollapsed ? ">" : ""}
      </td>
      {(modoCombinado ? hardwareMensualesCombinados : ingresosHardwareMensual).map((val, i) => (
        <td
          key={i}
          className="text-end"
          style={{
            cursor: !modoCombinado && !verUltimos12Meses && i < monthsToShow && val > 0 ? "pointer" : "default",
          }}
          onClick={(e) => {
            e.stopPropagation();
            if (!modoCombinado && !verUltimos12Meses && i < monthsToShow && val > 0) openHardwareIngresosModal(i);
          }}
        >
          {i < monthsToShow ? formatCurrency(val, i, null, modoCombinado) : "-"}
        </td>
      ))}
      <td className={styles.totalCell}>
        {modoCombinado
          ? formatCurrency(
              hardwareMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0),
              null,
              null,
              true
            )
          : formatCurrency(ytdIngresosHardware, null, ingresosHardwareMensual)}{" "}
        |{" "}
        {porcentajeSobreFacturacion(
          modoCombinado
            ? hardwareMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0)
            : ytdIngresosHardware
        )}
      </td>
    </tr>

    {!modoCombinado && !bloqueBCollapsed && (
      <>
        {/* 1. Compra hardware */}
        <tr>
          <td className={styles.conceptCell}>Compra hardware</td>
          {compraHardwareMensual.map((val, i) => (
            <td
              key={i}
              onClick={(e) => {
                e.stopPropagation();
                // v2: si la celda sale de facturas, abre su detalle.
                if (onDetalleFactura?.disponible(i)) {
                  onDetalleFactura.abrir("hardware", "Compra hardware", i);
                  return;
                }
                if (i < monthsToShow) openHardwareFlexModal(i);
              }}
              style={{ cursor: i < monthsToShow ? "pointer" : "default" }}
            >
              {i < monthsToShow ? formatCurrency(val, i) : "-"}
            </td>
          ))}
          <td className={styles.totalCell}>
            {formatCurrency(ytdCompraHardware, null, compraHardwareMensual)} |{" "}
            {ytdIngresosHardware > 0 ? formatPercentage((ytdCompraHardware / ytdIngresosHardware) * 100) : "0%"}
          </td>
        </tr>

        {/* 2. Instalación */}
        <tr>
          <td className={styles.conceptCell}>Instalación</td>
          {instalacionMensual.map((val, i) => (
            <td key={i} className="text-end">
              {i < monthsToShow ? formatCurrency(val, i) : "-"}
            </td>
          ))}
          <td className={styles.totalCell}>
            {formatCurrency(ytdInstalacion, null, instalacionMensual)} |{" "}
            {ytdIngresosHardware > 0 ? formatPercentage((ytdInstalacion / ytdIngresosHardware) * 100) : "0%"}
          </td>
        </tr>

        {/* 3. Materiales */}
        <tr>
          <td className={styles.conceptCell}>Materiales</td>
          {materialesMensual.map((val, i) => (
            <td key={i} className="text-end">
              {i < monthsToShow ? formatCurrency(val, i) : "-"}
            </td>
          ))}
          <td className={styles.totalCell}>
            {formatCurrency(ytdMateriales, null, materialesMensual)} |{" "}
            {ytdIngresosHardware > 0 ? formatPercentage((ytdMateriales / ytdIngresosHardware) * 100) : "0%"}
          </td>
        </tr>

        {/* 4. Otros costos */}
        <tr>
          <td className={styles.conceptCell}>Otros costos</td>
          {otrosCostosMensual.map((val, i) => (
            <td key={i} className="text-end">
              {i < monthsToShow ? formatCurrency(val, i) : "-"}
            </td>
          ))}
          <td className={styles.totalCell}>
            {formatCurrency(ytdOtrosCostosHardware, null, otrosCostosMensual)} |{" "}
            {ytdIngresosHardware > 0 ? formatPercentage((ytdOtrosCostosHardware / ytdIngresosHardware) * 100) : "0%"}
          </td>
        </tr>

        {/* Contribución B */}
        <tr className={styles.marginRow}>
          <td className={styles.conceptCellMargen}>Contribución</td>
          {ingresosHardwareMensual.map((ing, i) => {
            const totalCostos =
              compraHardwareMensual[i] + instalacionMensual[i] + materialesMensual[i] + otrosCostosMensual[i];
            const margen = ing - totalCostos;
            return (
              <td key={i} className="text-end">
                <div className={margen < 0 ? styles.marginNegative : ""}>
                  {i < monthsToShow ? formatCurrency(margen, i) : "-"}
                </div>
              </td>
            );
          })}
          <td className={styles.totalCell}>
            <div className={ytdMargenHardware < 0 ? styles.marginNegative : ""}>
              {formatCurrency(
                ytdMargenHardware,
                null,
                ingresosHardwareMensual.map(
                  (ing, i) =>
                    ing -
                    compraHardwareMensual[i] -
                    instalacionMensual[i] -
                    materialesMensual[i] -
                    otrosCostosMensual[i]
                )
              )}{" "}
              | {margenPorcentaje(ytdMargenHardware, ytdIngresosHardware)}
            </div>
          </td>
        </tr>
      </>
    )}
  </>
);
